'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http) {
    this.$http = $http;
  }

  $onInit() {
    this.getTutorial();
  }

  getTutorial() {
    this.$http.get('/api/tutorials').then(res => {
      this.tutorials = res.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete(`/api/tutorials/${id}`).then(res => {
        this.getTutorial();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/tutorial/list/list.controller.js